import { Component, ElementRef, ViewChild, AfterViewInit, TemplateRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as feather from 'feather-icons';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-file-upload-modal',
    templateUrl: './file-upload-modal.component.html',
    styleUrls: ['./file-upload-modal.component.scss'],
})
export class FileUploadModalComponent implements OnInit, AfterViewInit {
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;

    selectedFiles: File[] = [];
    selectedFile: File | null = null;
    pieceJointe = { nom: false, taille: false, derniereMiseAJour: false };
    readonly MAX_FILE_SIZE = 1024 * 1024; // 1MB
    private modalRef!: NgbModalRef;

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        console.log('FileUploadModalComponent: Initialized');
    }

    ngAfterViewInit(): void {
        this.refreshFeatherIcons();
    }

    openModal(): void {
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            windowClass: 'custom-modal-width', // Apply custom width class
            ariaLabelledBy: 'fileUploadModalLabel'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    triggerFileInput(event: MouseEvent): void {
        event.preventDefault();
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.click();
        } else {
            this.toastr.error("Erreur lors de l'ouverture du sélecteur de fichiers", 'Erreur');
        }
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const files = Array.from(input.files);
            if (files.length > 10) {
                this.toastr.error('Maximum 10 fichiers autorisés', 'Erreur');
                input.value = '';
                return;
            }
            const invalidFiles = files.filter(file => !file.name.endsWith('.pdf') || file.size > this.MAX_FILE_SIZE);
            if (invalidFiles.length > 0) {
                this.toastr.error('Seuls les PDFs de moins de 1 Mo sont autorisés', 'Erreur');
                input.value = '';
                return;
            }
            this.selectedFiles = files;
            this.selectedFile = files[0]; // For backward compatibility
            this.toastr.success(`${files.length} fichier(s) sélectionné(s)`, 'Succès');
            this.refreshFeatherIcons();
            this.cdr.markForCheck();
        }
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer?.files) {
            const files = Array.from(event.dataTransfer.files);
            if (files.length > 10) {
                this.toastr.error('Maximum 10 fichiers autorisés', 'Erreur');
                return;
            }
            const invalidFiles = files.filter(file => !file.name.endsWith('.pdf') || file.size > this.MAX_FILE_SIZE);
            if (invalidFiles.length > 0) {
                this.toastr.error('Seuls les PDFs de moins de 1 Mo sont autorisés', 'Erreur');
                return;
            }
            this.selectedFiles = files;
            this.selectedFile = files[0]; // For backward compatibility
            this.toastr.success(`${files.length} fichier(s) sélectionné(s)`, 'Succès');
            this.refreshFeatherIcons();
            this.cdr.markForCheck();
        }
    }

    importFile(): void {
        if (this.selectedFiles.length > 0) {
            this.toastr.success(`${this.selectedFiles.length} fichier(s) importé(s) avec succès`, 'Succès');
            this.clearFileSelection();
            this.modalRef.close('Import success');
        } else {
            this.toastr.error('Aucun fichier sélectionné', 'Erreur');
        }
    }

    private clearFileSelection(): void {
        this.selectedFiles = [];
        this.selectedFile = null;
        this.pieceJointe = { nom: false, taille: false, derniereMiseAJour: false };
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
        this.cdr.markForCheck();
    }

    private refreshFeatherIcons(): void {
        setTimeout(() => {
            feather.replace();
            this.cdr.markForCheck();
        }, 0);
    }
}
